<template>
  <CCard height="90px" width="260px" pointer @button-click="$emit('click')">
    <template v-slot:card-content>
      <div class="card-content">
        <div>
          <div class="card-section">
            <span class="user-name">{{ userInfo.name }}</span>
            <CCard
              singleText
              useSingleTextCenter
              width="38px"
              height="24px"
              pointer
              :fontColor="memberType.color"
              fontBackgroundColor="white"
              fontSize="10px"
              fontWeight="400"
              borderRadius="4px"
              :content="memberType.label">
            </CCard>
          </div>
          <div>
            <span class="company-name">{{ userInfo.companyName }}</span>
          </div>
        </div>

        <div class="icon-section">
          <img class="arrow-icon" :src="arrowIcon" />
        </div>
      </div>
    </template>
  </CCard>
</template>

<script>
import CCard from "@/components/common/CCard/CCard.vue";
import arrowIcon from "@/assets/img/mobile-nav-arrow.svg";

export default {
  name: "UserInfoCard",
  components: { CCard },
  props: {
    userInfo: {
      type: Object,
      required: true,
    },
    memberType: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      arrowIcon,
    };
  },
};
</script>

<style scoped>
.card-content {
  display: flex;
  justify-content: space-between;
  margin: 19px 10px 19px 24px;
}
.card-section {
  display: flex;
  gap: 8px;
}
.user-name {
  font-size: 18px;
  font-weight: 500;
  line-height: 26px;
  color: var(--gray-700);
}
.company-name {
  font-size: 14px;
  font-weight: 300;
  line-height: 22px;
  color: var(--gray-500);
}
.icon-section {
  display: flex;
  justify-content: center;
  align-items: center;
}
.arrow-icon {
  filter: brightness(0) saturate(100%) invert(95%) sepia(11%) saturate(446%) hue-rotate(181deg) brightness(92%)
    contrast(96%);
  width: 24px;
  height: 24px;
}
</style>
